import { render, staticRenderFns } from "./MedicationSensitivity.vue?vue&type=template&id=d9496348"
import script from "./MedicationSensitivity.vue?vue&type=script&lang=js"
export * from "./MedicationSensitivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports